import React, { useState } from "react";
import { Ban, FlaskConical, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";

import { Button } from "../../../components/ui/button";

import Bloco from "../../ofertas-do-dia/admin/regras/Bloco";
import { gerarPrevia } from "../api";

// Mostra uma mensagem de verdade da CLEO, com o tom e os exemplos que estão na tela.
export default function PreviaCleo({ cenarios, tom, exemplos }) {
  const [cenario, setCenario] = useState((cenarios || [])[0]?.id || "cardapio");
  const [carregando, setCarregando] = useState(false);
  const [resultado, setResultado] = useState(null);

  const gerar = async () => {
    setCarregando(true);
    try {
      setResultado(await gerarPrevia({ cenario, tom, exemplos: exemplos.filter((e) => e.trim()) }));
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Não foi possível gerar a mensagem");
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Bloco icone={FlaskConical} titulo="Teste a CLEO" corIcone="bg-amber-500/15 text-amber-500"
      subtitulo="Escolha uma situação e veja a mensagem que a CLEO escreveria agora, com as promoções e cupons ativos da loja.">
      <div className="flex flex-wrap gap-2">
        {(cenarios || []).map((c) => (
          <button key={c.id} type="button" onClick={() => setCenario(c.id)}
            className={`rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${cenario === c.id ? "border-amber-500 bg-amber-500/10" : "hover:border-amber-500/50"}`}>
            {c.rotulo}
          </button>
        ))}
        <Button type="button" onClick={gerar} disabled={carregando} className="ml-auto" data-e2e="gerar-previa">
          {carregando ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1.5" />}
          Gerar mensagem
        </Button>
      </div>
      {resultado && (
        <div className="mt-4 rounded-xl bg-[#0b141a] p-4" data-e2e="previa-cleo">
          {resultado.enviar ? (
            <div className="ml-auto max-w-[85%] w-fit rounded-lg rounded-tr-none bg-[#005c4b] px-3 py-2 text-sm text-white shadow">
              <p className="whitespace-pre-wrap leading-snug">{resultado.mensagem}</p>
              {(resultado.cenario !== "duvida" || resultado.incluir_link) && (
                <p className="text-[#53bdeb] text-xs mt-1 break-all">https://sualoja.usenucleo.com.br/?r=…</p>
              )}
            </div>
          ) : (
            <p className="flex items-center gap-2 text-sm text-zinc-300">
              <Ban className="w-4 h-4 text-zinc-400" /> A CLEO não mandaria mensagem aqui: {resultado.motivo || "não era hora"}.
            </p>
          )}
        </div>
      )}
    </Bloco>
  );
}
